export default __webpack_public_path__ + "static/media/logo.d66f4fa5.png";